<template>
  <div>
    <SectionThreeItemsHeader>
      <template v-slot:item-center>
        <h2>CV</h2>
      </template>
      <template v-slot:item-right>
        <EditCVAction />
      </template>
    </SectionThreeItemsHeader>
    <div v-if="isLoading" class="full-width">
      <v-skeleton-loader type="list-item" />
    </div>
    <CVUploader
      v-else-if="userData.cv"
      :currentWorker="userData"
      readonly
      showPreview
    />
  </div>
</template>

<script>
import CVUploader from "@/components/workers/CVUploader";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { createNamespacedHelpers } from "vuex";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import EditCVAction from "@/views/settings/components/actions/EditCVAction";
import { GET_IS_EDITING_USER_DETAILS } from "@/store/modules/users/getters";
import { USERS_NAMESPACE } from "@/store/modules/users";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapGetters: mapUserGetters } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  components: {
    CVUploader,
    SectionThreeItemsHeader,
    EditCVAction
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapUserGetters({
      isLoading: GET_IS_EDITING_USER_DETAILS
    })
  }
};
</script>

<style lang="scss" scoped></style>
